// What kind of CSV a file is, decided once and the same way for every parser:
// the profiler in disclosure_core.js (which also runs in the browser, so this
// stays dependency-free) and the ingest's csv-parse in ingest_core.js. A file
// profiled with `;` is ingested with `;`.

export const SEPARATORS = [',', ';', '\t'];

export const stripBom = (text) => String(text).replace(/^﻿/, '');

// The separator is the candidate that occurs most often in the header row,
// outside quotes. A header with none of them (a single column) is read as
// comma-separated, as before.
export function detectSeparator(csvText) {
  const text = stripBom(csvText);
  const counts = new Map(SEPARATORS.map((s) => [s, 0]));
  let quoted = false;
  for (const char of text) {
    if (char === '"') quoted = !quoted;
    else if (!quoted && (char === '\n' || char === '\r')) break;
    else if (!quoted && counts.has(char)) counts.set(char, counts.get(char) + 1);
  }
  let best = ',';
  for (const [separator, count] of counts) if (count > counts.get(best)) best = separator;
  return best;
}
